module.exports = __webpack_public_path__ + "img/gruppen_diagnose_08.2970ced5.png";